import { gql } from 'graphql-tag'

import { FRAGMENT_AVATAR_USER } from '@/components/Worlds/UI/Avatar/Avatar.hasura'

export const FRAGMENT_CONVERSATION_USERS_SEEN_CONVERSATION_USER = gql`
  fragment ConversationUsersSeenConversationUser on conversation_user {
    id
    last_read_at
    user {
      id
      virtual_display_name
      ...AvatarUser
    }
  }
  ${FRAGMENT_AVATAR_USER}
`
